import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { adminLogin } from "../../lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await adminLogin(email.trim(), password);
      navigate("/admin/photographs", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      setError(typeof d === "string" ? d : "Invalid credentials");
    } finally {
      setBusy(false);
    }
  }

  return (
    <main
      data-testid="admin-login-page"
      className="min-h-screen bg-[color:var(--bg)] text-white flex items-center justify-center px-6 grain"
    >
      <form
        onSubmit={onSubmit}
        data-testid="admin-login-form"
        className="w-full max-w-sm space-y-6 border border-white/10 rounded-md p-8 bg-black/30 backdrop-blur"
      >
        <h1 className="font-serif-display italic text-2xl text-white/85">Admin</h1>

        <label className="block">
          <span className="block text-xs uppercase tracking-[0.24em] text-white/45 mb-2 font-serif-display italic">
            Email
          </span>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            autoFocus
            data-testid="admin-login-email"
            className="q-input"
          />
        </label>

        <label className="block">
          <span className="block text-xs uppercase tracking-[0.24em] text-white/45 mb-2 font-serif-display italic">
            Password
          </span>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            data-testid="admin-login-password"
            className="q-input"
          />
        </label>

        {error && (
          <p data-testid="admin-login-error" className="text-sm text-red-300/85 font-serif-display italic">
            {error}
          </p>
        )}

        <button
          type="submit"
          disabled={busy}
          data-testid="admin-login-submit"
          className="btn-ghost w-full disabled:opacity-40"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
